import React from 'react';

function Header() {
  return (
    <div style={styles.headerContainer}>
      <h1 style={styles.heroTitle}>AIVAN</h1>
      <p style={styles.tagline}>Your AI-some Venture Copilot</p>
    </div>
  );
}

const styles = {
  headerContainer: {
    width: '100%', // Full width of the browser window
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#007bff',
    color: 'white',
    borderBottom: '2px solid #0056b3',
    boxSizing: 'border-box', // Include padding in width calculations
  },
  heroTitle: {
    fontSize: '2.5rem',
    margin: '0',
    fontWeight: '700',
    fontFamily: 'Arial, sans-serif',
  },
  tagline: {
    fontSize: '1.2rem',
    margin: '0',
    fontFamily: 'Arial, sans-serif',
  },
};

export default Header;